import * as jsyaml from 'js-yaml';

const cachedSpecs = {
  merchant: {
    v1: null,
    v2: null,
  },
  iso: {
    v1: null,
  },
};
const rawYamlUrls = {
  merchant: {
    v1: '/schemas/api/api-v1.yml',
    v2: '/api/v2/spec',
  },
  iso: {
    v1: '/api/iso/v1/spec',
  },
};

/**
 * @param {string} type
 * @param {string} version
 * @param {object} branding
 * @returns {Promise<object>}
 */
export async function getSpec(type, version, branding) {
  if (cachedSpecs[type][version]) return cachedSpecs[type][version];

  const rawYamlUrl = rawYamlUrls[type][version];
  const res = await fetch(rawYamlUrl);
  const rawYaml = await res.text();

  // Whitelabel
  const parsedYaml = _interpolate(rawYaml, branding);

  // Parse YAML to object
  const schema = jsyaml.load(parsedYaml);

  // Remove the logo, since there's a logo in the navbar
  if (schema.info?.['x-logo']) delete schema.info['x-logo'];

  cachedSpecs[type][version] = schema;

  return schema;
}

/**
 * Replace `{{variableName}}` with the corresponding key from the branding.
 * @param {string} rawYaml
 * @param {Record<string, string>} branding
 * @returns {string}
 */
function _interpolate(rawYaml, branding) {
  const matches = rawYaml.match(/{{(\w+)}}/g);
  if (!matches) return rawYaml;

  return matches.reduce((parsed, prop) => {
    const regex = new RegExp(prop.replace(/({)/, '\$1'), 'g');
    const replace = branding[prop.slice(2, -2).trim()];
    return parsed.replace(regex, replace, rawYaml);
  }, rawYaml);
}
